var ProductTags=$("#Product-specification-recommendation").data("tags");
var Ezpid=$("#Product-specification-recommendation").data("ezpid");
if(ProductTags!=""){
  jQuery.getJSON("/search/suggest.json",{
    "q":ProductTags,
    "resources":{
      "type":"product",
      "limit":4,
      "options":{"unavailable_products":"last","fields":"tag"}
    }
  }).done(function(response){
    var productSuggestions=response.resources.results.products;
    if(productSuggestions.length != 0 && productSuggestions.length != 1){
      $.each(productSuggestions,function(key,val){
        jQuery.getJSON("/products/"+val.handle+".js",function(product){
          if(product.id!=Ezpid){NestRecommendProduct(product)}
        })
      })
    }else{
    	$(".recommendation").css("display","none");
    }
  })
}else{
  $(".recommendation").css("display","none");
  $(".related-product").css("display","none");
  $("#Product-specification").remove();
}
function NestRecommendProduct(product){

  $("#Product-specification .grid_view_pridoct_view2").attr("href",product.url);
  $("#Product-specification .recommenc_img").attr("src",product.images[0]);
  $("#Product-specification .product_grid_product1").html(product.title);
  $("#Product-specification .sales_price").html((product.price*0.01).toFixed(2));
//   if(product.compare_at_price!=null){
//     $("#Product-specification .original_cost").html((product.compare_at_price*0.01).toFixed(2))
//   }
  $("#Product-specification-recommendation").append($("#Product-specification").html())
};